import { Text } from "@shared/components/text";
import { View } from "react-native";
import { useTranslation } from "react-i18next";

interface QuestionnaireProgressBarProps {
  currentStepIndex: number;
  totalSteps: number;
}

export const QuestionnaireProgressBar = ({ currentStepIndex, totalSteps }: QuestionnaireProgressBarProps) => {
  const { t } = useTranslation();
  const currentProgress = totalSteps > 0 ? ((currentStepIndex + 1) / totalSteps) * 100 : 0;

  return (
    <View className="flex-row items-center mb-2">
      <View className="flex-[12] h-3 bg-gray-200 rounded-full overflow-hidden">
        <View
          className="h-full bg-secondary-600 rounded-full"
          style={{ width: `${currentProgress}%` }}
        />
      </View>
      <View className="flex-[3] pl-1">
        <Text className="text-right">
          {t("screens.activities.questionnaire.questionCounter", {
            current: Math.min(currentStepIndex + 1, totalSteps),
            total: totalSteps,
          })}
        </Text>
      </View>
    </View>
  );
};
